import { useEffect } from 'react';
import { ReactComponent as DHLLogo } from '../../resources/images/dhl_logo.svg';
import { languageMap } from '../../maps/languageMap';
import { useActions, useTypedSelector } from '../../hooks';
import { navigationPages } from '../../models/types';
import { useHistory } from 'react-router-dom';
import './styles/ThankYouStyle.css';

const ThankYou: React.FC = () => {
  let history = useHistory();
  const language = useTypedSelector(({ session }) => {
    return session.language;
  });
  const { lockerReset } = useActions();
  useEffect(() => {
    const timer = setTimeout(() => {
      lockerReset();
      history.replace(`/${navigationPages.LANDING}`);
    }, 8000);
    return () => clearTimeout(timer);
  }, [lockerReset, history]);

  return (
    <div id="thank-you" className="main-container">
      <div className="thankyou-image-container">
        <div
          className="thankyou-image-container thankyou-image active"
          id="thank-you-image"
        />
      </div>
      <div className="banner-right" />
      <div className="banner-right-message-container">
        <DHLLogo className="dhl-logo-right" />
        <p className="banner-header-right">
          {languageMap.thank_you.title[language]}
        </p>
      </div>
    </div>
  );
};

export { ThankYou };
